import React from 'react';
import 'index.css'

import Aurora from 'components/ui/Aurora';

const handleMouseMove = e => {
  const { currentTarget: target } = e;
  const rect = target.getBoundingClientRect(),
    x = e.clientX - rect.left,
    y = e.clientY - rect.top;
  target.style.setProperty("--mouse-x", `${x}px`);
  target.style.setProperty("--mouse-y", `${y}px`);
}

for(const card of document.getElementsByClassName("card")) {
  card.onmousemove = e => handleMouseMove(e);
}

function Background() {
  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-10">
      <Aurora
        colorStops={["#FFB232", "#FFB232", "#FFB232"]}
        blend={0.5}
        amplitude={0.3}
        speed={0.7}
      />
    </div>
  );
}

function Small() {
  return (
    <div class="flex flex-col flex-grow w-full h-full items-start justify-start md:justify-start min-h-svh cursor-auto selection:bg-[#FFB232] selection:text-black z-20">

      <div class="flex flex-row w-full p-5 justify-center items-center">
        <img src="./Logo.png" className="h-[2.8rem] ml-3" alt="Takes Form Logo"/>
      </div>

      <div class="flex flex-col w-full h-full flex-grow p-10 justify-start md:justify-center gap-10">
        <div class="card flex flex-row justify-between items-center w-full">
          <div class="flex flex-col leading-3">
            <h1 className="m-0 p-0 text-6xl leading-[3rem] sm:text-8xl sm:leading-[5rem] hover:text-[#FFB232]">Where I Work</h1>
          </div>
        </div>

        <div class="flex flex-col items-start h-full max-w-[32rem]">
          <div class="flex flex-col gap-4">
            <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">A data scientist enhancing the way we communicate complex insights.</p>
            <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">Currently working in the sports industry, you'll find me uncovering compelling stories about fan behaviours and crafting personalised fan experiences.</p>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <a class="card w-fit p-4 text-[1.0rem] font-[SplineSans-Regular] bg-[#101027] hover:text-[#FFB232]" href="https://www.linkedin.com/in/max-hornigold-603238206/">
            LinkedIn
          </a>
          <h2 class="card w-fit p-4 text-[1.0rem] font-[SplineSans-Regular] bg-[#101027] hover:text-[#FFB232]">
            mchornigold@gmail.com
          </h2>
        </div>

      </div>
    </div>
  )
}

function Page() {  
  if (window.innerWidth < 768) {
    return (
      <div className="h-full relative w-full overflow-hidden flex flex-col items-center justify-center rounded-none">
        <Background />
        <Small />
      </div>
    );
  } 
  return (
    <div className="h-full relative w-full overflow-hidden flex flex-col items-center justify-center rounded-none">
      <Background />
      <div class="flex flex-col flex-grow w-full h-full items-start justify-start md:justify-start min-h-svh cursor-auto selection:bg-[#FFB232] selection:text-black z-20">

        <div class="flex flex-row w-full p-5 justify-between items-center">
          <a href="/"><img src="./Logo.png" className="h-[2.8rem] ml-3" alt="Takes Form Logo"/></a>
          <div class="flex flex-row gap-3">
            <a class="card w-fit p-4 rounded-2xl text-[1.0rem] font-[SplineSans-Regular] bg-[#101027] hover:text-[#FFB232] hover:bg-[#29284a90]" href="https://www.linkedin.com/in/max-hornigold-603238206/">
              LinkedIn
            </a>
            <h2 class="card w-fit p-4 rounded-2xl text-[1.0rem] font-[SplineSans-Regular] bg-[#101027] hover:text-[#FFB232] hover:bg-[#29284a90]">
              mchornigold@gmail.com
            </h2>
          </div>

        </div>

        <div class="flex flex-row w-full h-full flex-grow items-center">

          <div class="flex flex-col w-full h-full flex-grow p-10 justify-start md:justify-center gap-10">
            
            <div class="card flex flex-row justify-between items-center w-full">
              <div class="flex flex-col leading-3">
                <h1 className="m-0 p-0 text-6xl leading-[3rem] sm:text-8xl sm:leading-[5rem] hover:text-[#FFB232]">Where I Work</h1>
              </div>
            </div>

            <div class="flex flex-col items-start h-full max-w-[32rem]">
              <div class="flex flex-col gap-4">
                <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">I'm experienced across the entire data pipeline, regularly leading projects from data to strategy and everything in between.</p>
                <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">This condensed experience has propelled my in my career to date, and shaped me as a well-rounded and efficient where possible.</p>
                <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">That being said, everyone has favourites and mine is clearly analytics engineering and everything that goes into improving the capabilities of our existing processes.</p>
              </div>
            </div>

          </div>

          <div class="flex flex-col w-full gap-2 items-center text-center">
            <div class="p-3 rounded-2xl w-[160px] bg-[#FFB232] text-[#101027]">Data engineering</div>
            <div class="p-3 rounded-2xl w-[200px] bg-[#FFB232] text-[#101027]">Data Science</div>
            <div class="p-3 rounded-2xl w-[280px] bg-[#FFB232] text-[#101027]">Analytics Engineering</div>
            <div class="p-3 rounded-2xl w-[350px] bg-[#FFB232] text-[#101027]">BI Development</div>
            <div class="p-3 rounded-2xl w-[220px] bg-[#FFB232] text-[#101027]">Analytics</div>
            <div class="p-3 rounded-2xl w-[240px] bg-[#FFB232] text-[#101027]">Strategy</div>
          </div>
        
        </div>

      </div>
    </div>
  );
}
export default Page;